module.exports = __webpack_public_path__ + "img/doctor_black.8b9e6987.svg";